module.exports = __webpack_public_path__ + "fonts/HelveticaNowMicro-MedIta.eaaf1b03.woff2";